export default "__VITE_ASSET__8a24c876__"